












































































































































































































































































import { calcProgn } from '@/modules/budget-request/components/js/budgetCalcProgn';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { Component, Vue, Prop } from 'vue-property-decorator';
import store from '@/services/store';
import { setNameLang, makeToast } from '@/modules/budget-request/components/js/some-functions';
import { getBudgetText }  from '@/modules/budget-request/components/budget-sum-calc/js/budget-translation';
import CAddModal from '@/modules/budget-request/budget-gkkp/c-add-modal.vue';
import CNumberInput from '@/components/c-number-input/index.vue';
import CBudgetCheckupModal from '@/modules/budget-request/budget-event/budget-checkup-modal.vue';
import CBudgetPartialSaveModal from '@/modules/budget-request/budget-event/budget-partial-save-modal.vue';
import CBudgetAgreementModal, { iAgrBtns } from '@/modules/budget-request/components/budget-sum-calc/budget-agreement-modal.vue';
import CBudgetAgreementLogModal from '@/modules/budget-request/budget-event/budget-event-agreement-log-modal.vue';

/**
 * task-eak-726, этап 4: группа (prg, ppr, project, gu), отклонённая эндпоинтом
 * save-budget-events-abp при частичном сохранении. ppr - сентинел -1 "без ППР" (как в ответе сервера).
 */
interface iSaveGroupRejected {
    prg: number;
    ppr: number;
    project: string;
    gu: string;
    errCode: string;
    errTxt: string;
}

interface iSaveResponse {
    result: 'success' | 'error';
    errCode: string | null;
    errTxt: string | null;
    groups: iSaveGroupRejected[];
}

/**
 * возврат saveClk/saveClkInner: boolean не годится, т.к. есть третий исход - частичное
 * сохранение (не всё, но и не ничего). ok=true только при полном успехе (rejected пуст).
 */
interface iSaveResult {
    ok: boolean;
    rejected: iSaveGroupRejected[];
}

/**
 * серверный предел - не больше 500 групп (prg, ppr, project, gu) в одном
 * запросе save-budget-events-abp (иначе отказ всей формы, код LIMIT_EXCEEDED, ничего не
 * записано). Режем пакет по группам заранее, с запасом от предела - на случай расхождения
 * в подсчёте групп между фронтом и сервером.
 */
const SAVE_CHUNK_GROUP_SIZE = 100;

/**
 * не больше N кусков одновременно в полёте: каждый запрос save-budget-events-abp держит
 * отдельное соединение к БД (на сервере PooledPostgresqlDatabase с max_connections=40,
 * timeout=None) - при исчерпании пула лишние запросы ждут свободное соединение бесконечно,
 * а не падают с ошибкой. Безлимитный Promise.all по числу кусков большой формы одним
 * пользователем способен выгрести весь пул.
 */
const SAVE_CHUNK_CONCURRENCY = 4;

@Component({
    name: 'c-bud-event-abp',
    components: {
        'c-add-modal': CAddModal,
        'c-number-input': CNumberInput,
        'c-checkup-modal': CBudgetCheckupModal,
        'c-partial-save-modal': CBudgetPartialSaveModal,
        'c-agr-log-modal': CBudgetAgreementLogModal,
        'c-budg-agr-modal': CBudgetAgreementModal
    }
})
export default class CBudgetEventAbp extends Vue {
    @Prop({
        required: true
    })
    private curFilter!: any;

    @Prop({
        required: true,
        default: false
    })
    private editableProp!: boolean;

    @Prop({
        required: true,
        default: 0
    })
    private typeAgrProp!: number;

    @Prop({
        required: false,
        default: 1
    })
    private yearCountProp!: number;

    private get editable() {
        // пока снимки не построены, править нечего: любой ранний выход из loadData оставляет их null
        return this.editableProp && this.histDataMap !== null && this.histCategoryMap !== null;
    }

    private progress = 0;
    private collapseAll = true;

    private curYear: number = (new Date()).getFullYear();;
    private curRegion: any | null = null;
    private curDataType: any | null = null;
    private curVariant: any | null = null;
    private curAbp: any | null = null;
    private curGuLst: any[] | null = null;
    private curProg: any | null = null;
    private curSubProg: any | null = null;
    private variantEndDate: any | null = null;
    private curStatus: any | null = null;

    private justTxt: string = '';
    private showJustModal = false;
    private selectedProjIndx: number | null = null;
    private justEditable = false;

    private categoryBase: any[] = [];
    private totalSum: any = { abp_value0: 0, gu_value0: 0, uo_value0: 0, abp_value1: 0, gu_value1: 0, uo_value1: 0, abp_value2: 0, gu_value2: 0, uo_value2: 0 }

    private get allCategory() {
        const res: any[] = [{name: '---', code: null}];
        for (const el of this.categoryBase) {
            const tmpObj = setNameLang(this.$i18n.locale, el);
            res.push(tmpObj);
        }
        return res;
    }

    private readonly modeCode = 'br_project';
    private operationCode: string[] = []; // операции согласования уровень ГУ
    private operationCodeProj: string[] = []; // операции согласования уровень мероприятий
    private agrBtnLst: iAgrBtns = { back: [], forward: [] };
    private selectArr: any = [];
    private typeAgr = 0; // 0 - gu, 1 - project

    private yearCount = 1; // период планирования: 1 год или 3 года

    /**
     * при периоде "1 год" колонки curYear+1 и curYear+2 не выводятся в DOM
     */
    private get showAllYears() {
        return this.yearCount !== 1;
    }

    private checkedAll = false;

    private get usrId(): string | null {
        if (!store.state.user.sub) { return null; }
        return store.state.user.sub;
    }

    private dataLst: any[] = [];
    private histDataMap: Map<string, Map<string, any>> | null = null;
    private histCategoryMap: Map<string, Map<string, any>> | null = null;
    private isDirty = false; // есть несохранённые изменения (пересчитывается по событию, а не на каждое нажатие клавиши)
    // пары (prg, ppr, project, category), по которым у УО есть непустые суммы - подсказка для блокировки смены категории
    private uoBusyCategories: any[] = [];

    private readonly moduleCode = '004.010.002';
    private readonly moduleCodeUO = '004.010.002.001'; // виртуальный код для согласования на уровне мероприятий

    private checkupData: any[] = [];

    // ------------------------ занятость: защита от повторного нажатия кнопок
    // флаг на каждый процесс, а не один общий счётчик: процессы вложены друг в друга
    private loadingFl = false; // идёт загрузка данных
    private savingFl = false; // идёт сохранение
    private agreeingFl = false; // идёт согласование, включая время, пока открыта модалка
    // статус, который видел пользователь при открытии модалки согласования - отправляем на сервер
    // для проверки, что за время открытой модалки статус в БД не изменился (чужое согласование)
    private agrCurrentStatus: number | null = null;

    private loadSeq = 0; // поколение загрузки: loadData могут вызвать повторно, пока предыдущая ещё в полёте

    private get busy(): boolean {
        return this.loadingFl || this.savingFl || this.agreeingFl;
    }
    // ------------------------

    private mounted() {
        this.$emit('chgBusy', false);
        this.$watch('busy', (busy: boolean) => { this.$emit('chgBusy', busy); });
        this.$emit('chgEditable', this.editable);
        this.$watch('editable', (editable: boolean) => { this.$emit('chgEditable', editable); });
        this.loadAllCategory();
        this.curYear = this.curFilter.curYear;
        this.curRegion = this.curFilter.curRegion;
        this.curDataType = this.curFilter.curDataType;
        this.curVariant = this.curFilter.curVariant;
        this.curAbp = this.curFilter.curAbp;
        this.curProg = this.curFilter.curProg;
        this.curSubProg = this.curFilter.curSubProg;
        this.variantEndDate = this.curFilter.variantEndDate;
        this.curGuLst = this.curFilter.guLst ? this.curFilter.guLst: [this.curFilter.curGu];
        this.curStatus = this.curFilter.curStatus

        this.typeAgr = this.typeAgrProp;
        this.yearCount = this.yearCountProp;
        this.loadData();
    }

    private chgEvent(params: any) {
        this.curYear = params.curYear;
        this.curRegion = params.curRegion;
        this.curDataType = params.curDataType;
        this.curVariant = params.curVariant;
        this.curAbp = params.curAbp;
        this.curProg = params.curProg;
        this.curSubProg = params.curSubProg;
        this.variantEndDate = params.variantEndDate;
        this.curGuLst = params.guLst ? params.guLst: [params.curGu];
        this.curStatus = params.curStatus;
        this.loadData();
    }

    private chgTypeAgr(type: number) {
        this.typeAgr = type;
    }

    /**
     * период планирования (1 год / 3 года) - переключается без перезагрузки данных
     */
    private chgYearCount(value: number) {
        this.yearCount = value;
    }

    private async loadData() {
        const seq = ++this.loadSeq;
        this.loadingFl = true;
        try {
            await this.loadDataInner();
        } catch (error) {
            this.progress = 100;
            makeToast(this, 'danger', this.tblTitle.load_data, (error as Error).toString());
        } finally {
            // если поверх этой загрузки уже начали новую - флаг снимет она
            if (seq === this.loadSeq) { this.loadingFl = false; }
        }
    }

    private async loadDataInner() {
        this.dataLst = [];
        this.checkedAll = false;
        this.histDataMap = null;
        this.histCategoryMap = null;
        this.isDirty = false; // синхронно: пока снимка нет, несохранённых изменений быть не может
        this.totalSum = { abp_value0: 0, gu_value0: 0, uo_value0: 0, abp_value1: 0, gu_value1: 0, uo_value1: 0, abp_value2: 0, gu_value2: 0, uo_value2: 0 };
        if (!this.curAbp || !this.curDataType || !this.curRegion || !this.curVariant || !this.curGuLst || !this.curProg) {
            return
        }
        const guLst = [];
        for (const el of this.curGuLst) {
            guLst.push(el.code);
        }
        if (!guLst.length) { return; }
        this.progress = 30;
        const versYear =  ((this.curDataType && this.curDataType.code == '2') ? this.curVariant.year: null);
        const params = { curYear: this.curYear, abp: this.curAbp.abp, dataType: this.curDataType.code, region: this.curRegion.code, variant: this.curVariant.variant_uuid, guLst: guLst, date_b: this.curVariant.date_start, date_e: this.variantEndDate, prg: this.curProg.prg, ppr: this.curSubProg ? this.curSubProg.ppr: -1, locale: this.$i18n.locale, vers_year: versYear };

        const loadResult = await Promise.all([
            this.loadProjectData(params),
            this.loadJustification(params),
            this.loadCategoryData(params),
            this.loadUOsum(),
            this.loadUOBusyCategories(),
            this.loadAgreementGuLvl(),
            this.loadAgreementProjLvl()
        ]);
        const projectData = loadResult[0];
        const justificationData = loadResult[1];
        const categoryData = loadResult[2];
        const uoSum = loadResult[3];
        const uoBusyCategories = loadResult[4];
        const agrGuLvlMap: Map<any, any> = loadResult[5];
        const agrProjLvlMap: Map<string, any> = loadResult[6];
        if (!projectData || !justificationData || !categoryData || !uoSum) { return; }

        this.uoBusyCategories = uoBusyCategories;
        this.progress = 70
        this.getTreeData(projectData, justificationData, categoryData, uoSum, agrGuLvlMap, agrProjLvlMap);
        this.progress = 100;
    }

    private getTreeData(baseData: any[], justData: any[], categoryData: any[], uoSum: any[], agrGuLvlMap: Map<any, any>, agrProjLvlMap: Map<string, any>) {
        baseData.sort((a: any, b: any) => (`${a.prg.prg}_${a.ppr.ppr ? a.ppr.ppr:'000'}_${a.project.code}` > `${b.prg.prg}_${b.ppr.ppr ? b.ppr.ppr:'-1'}_${b.project.code}`) ? 1 : -1);
        let result: any[] = [];
        for (let i = 0; i < baseData.length; i++) {
            const el = baseData[i];
            if (result.length == 0 || (result[result.length -1].project.code != el.project.code || result[result.length -1].prg.prg != el.prg.prg || result[result.length -1].ppr.ppr != el.ppr.ppr)) {
                const obj = {project: el.project, prg: el.prg, ppr: el.ppr, justTxt: '', uo_value0: null, uo_value1: null, uo_value2: null, collapse: this.collapseAll, totalSum: { gu_value0: 0, gu_value1: 0, gu_value2: 0, abp_value0: 0, abp_value1: 0, abp_value2: 0 },  items: []};
                this.setProjLvlAgreement(obj, agrProjLvlMap);
                this.setJustTxt(obj, justData);
                this.setUOsum(obj, uoSum);
                if (result.length !== 0) { result[result.length - 1].items = this.setGuLvl(result[result.length - 1].items, result[result.length - 1], categoryData, agrGuLvlMap); }
                result.push(obj);
            }
            result[result.length-1].items.push(el);
            if (i == baseData.length - 1) { result[result.length - 1].items = this.setGuLvl(result[result.length - 1].items, result[result.length - 1], categoryData, agrGuLvlMap); }
            for (let i = 0; i < 3; i++) {
                this.totalSum[`uo_value${i}`] += result[result.length-1][`uo_value${i}`] ?? 0;
            }
        }
        this.setHistDataMap(result);
        // --- фильтр по статусам
        if (this.curStatus?.code != null) {
            this.totalSum = { abp_value0: 0, gu_value0: 0, uo_value0: 0, abp_value1: 0, gu_value1: 0, uo_value1: 0, abp_value2: 0, gu_value2: 0, uo_value2: 0 };
            result = result.filter(el => {
                if (el.agrProjLvl?.status?.code !== this.curStatus.code) {
                    return false;
                }

                for (let i = 0; i < 3; i++) {
                    this.totalSum[`uo_value${i}`] += el[`uo_value${i}`] ?? 0;
                }

                this.calcTotal(this.totalSum, el.totalSum);

                return true;
            });
        }
        this.dataLst = result;
    }

    private setProjLvlAgreement(obj: any, agrProjLvlMap: Map<string, any>) {
        const key = `${obj.prg.prg}_${obj.ppr?.ppr ?? '00'}_${obj.project.code}`;
        const agrObj = agrProjLvlMap.get(key);
        if (!agrObj) { return; }
        obj.agrProjLvl = {};
        obj.agrProjLvl.status = setNameLang(this.$i18n.locale, agrObj.status);
        obj.agrProjLvl.agr_id = agrObj.id;
        obj.agrProjLvl.update_date = agrObj.update_date;
        obj.agrProjLvl.user_id = agrObj.user_id;
        obj.agrProjLvl.comment_txt = agrObj.comment_txt;
        if (agrObj.availableStep) {
            obj.checked = this.checkedAll;
            obj.agrProjLvl.availableStep = true;
        }
    }

    private setUOsum(obj: any, uoSum: any[]) {
        for (let i = 0; i < uoSum.length; i++) {
            const el = uoSum[i];
            if (el.prg === obj.prg.prg && el.ppr === obj.ppr.ppr && el.project === obj.project.code) {
                obj.uo_value0 = el.uo_value0;
                obj.uo_value1 = el.uo_value1;
                obj.uo_value2 = el.uo_value2;
                uoSum.splice(i, 1);
                return;
            }
        }
    }

    private setJustTxt (obj: any, justData: any[]) {
        if (!justData.length) { return; }
        const indx = justData.findIndex((el: any) => el.prg == obj.prg.prg && el.ppr == obj.ppr.ppr && el.project_code == obj.project.code);
        if (indx >= 0) {
            obj.justTxt = justData[indx].just_txt;
            justData.splice(indx, 1);
        }
    }

    private setGuLvl(items: any[], projObj: any, categoryData: any[], agrGuLvlMap: Map<any, any>) {
        const total = projObj.totalSum;
        items.sort((a: any, b: any) => (a.gu.code > b.gu.code) ? 1 : -1);
        const result: any[] = [];
        let maxAgrCode = -1;
        for (let i = 0; i < items.length; i++) {
            const el = items[i];
            if (result.length == 0 || result[result.length -1].gu.code != el.gu.code) {
                const obj = {gu: el.gu, category: null, category_editable: false, category_busy: false, collapse: this.collapseAll, totalSum: { gu_value0: 0, gu_value1: 0, gu_value2: 0, abp_value0: 0, abp_value1: 0, abp_value2: 0 },  items: []};
                this.setCategoryData(obj, categoryData, projObj);
                obj.category_busy = this.isCategoryBusy(projObj.prg.prg, projObj.ppr.ppr, projObj.project.code, obj.category);
                if (result.length !== 0) { result[result.length - 1].items.sort((a: any, b: any) => (a.spf.spf > b.spf.spf) ? 1 : -1); }
                result.push(obj);
                maxAgrCode = -1;
            }
            const guObj = result[result.length-1];
            this.calcTotal(guObj.totalSum, el);
            this.calcTotal(total, el);
            this.calcTotal(this.totalSum, el);
            this.setGuLvlAgreement(el, projObj, guObj, agrGuLvlMap);
            if (el.agrGuLvl && el.agrGuLvl.status && el.agrGuLvl.status.code && el.agrGuLvl.status.code > maxAgrCode) {
                maxAgrCode = el.agrGuLvl.status.code;
                guObj.category_editable = el.agrGuLvl.category_editable;
                if (guObj.category_editable) { projObj.just_editable = true; }
            }
            guObj.items.push(el);
            if (i == items.length - 1) { guObj.items.sort((a: any, b: any) => (a.spf.spf > b.spf.spf) ? 1 : -1); }
        }
        return result;
    }

    private setGuLvlAgreement(el: any, projObj: any, guObj: any, agrGuLvlMap: Map<any, any>) {
        const key = `${projObj.prg.prg}_${projObj.ppr?.ppr ?? '00'}_${projObj.project.code}`;

        const agrEl = agrGuLvlMap
            ?.get(key)
            ?.get(el.gu.code)
            ?.get(el.spf.spf);

        if (agrEl) {
            el.agrGuLvl = {};
            el.agrGuLvl.status = setNameLang(this.$i18n.locale, agrEl.status);
            el.agrGuLvl.agr_id = agrEl.id;
            el.editable = this.editableStep(agrEl, 'events_abp_edit');
            el.agrGuLvl.category_editable = this.editableStep(agrEl, 'events_abp_category_edit');
            el.agrGuLvl.update_date = agrEl.update_date;
            el.agrGuLvl.user_id = agrEl.user_id;
            el.agrGuLvl.comment_txt = agrEl.comment_txt;
            if (agrEl.availableStep) {
                el.checked = this.checkedAll;
                projObj.checked = this.checkedAll;
                guObj.checked = this.checkedAll;
            }
        }
    }

    private editableStep(projAgr: any, operation: string) {
        if (projAgr && projAgr.operation_codes) {
            for (const el of projAgr.operation_codes) {
                if (el  === operation) {
                    return true;
                }
            }
        }
        return false;
    }

    private setCategoryData(guObj: any, categoryData: any[], projObj: any) {
        if (!categoryData.length) { return; }
        for (let i = 0; i < categoryData.length; i++) {
            const el = categoryData[i];
            if (el.prg === projObj.prg.prg && el.ppr === projObj.ppr.ppr && el.project === projObj.project.code && el.gu === guObj.gu.code) {
                guObj.category = el.category;
                categoryData.splice(i, 1);
                return;
            }
        }
    }

    private calcTotal (parentTotal: any, item: any) {
        for (let i = 0; i < 3; i++) {
            if (item[`gu_value${i}`]) { parentTotal[`gu_value${i}`] += item[`gu_value${i}`]}
            if (item[`abp_value${i}`]) { parentTotal[`abp_value${i}`] += item[`abp_value${i}`]}
        }
    }

    private async loadJustification(params: any) {
        try {
            const url = '/api-py/get-budget-events-justification';
            let response: any = await fetch(url, {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(params)
            });
            response = await response.json();
            return response;
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка get-budget-events-justification', (error as Error).toString());
            return null;
        }
    }

    private async loadProjectData(params: any) {
        try {
            const url = '/api-py/get-budget-events-gu-abp-for-abptab';
            let response: any = await fetch(url, {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(params)
            });
            response = await response.json();
            return response;
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка загрузки', (error as Error).toString());
            return null;
        }
    }

    private async loadUOsum() {
        let result: any = null;
        const params = { curYear: this.curYear, abp: this.curAbp.abp, dataType: this.curDataType.code, region: this.curRegion.code, variant: this.curVariant.variant_uuid, prg: this.curProg.prg, ppr: this.curSubProg ? this.curSubProg.ppr: -1 };
        try {
            const response = await fetch(`/api-py/get-budget-event-uo-sum-for-abp/${encodeURI(JSON.stringify(params))}`);
            if (response.status === 200) {
                result = await response.json();
                return result;
            } else {
                makeToast(this, 'danger', 'Ошибка get-budget-event-uo-sum-for-abp', `${response.status} - ${response.statusText}`);
                return null;
                }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка get-budget-event-uo-sum-for-abp', (error as Error).toString());
            return null;
        }
    }

    /**
     * пары (prg, ppr, project, category), по которым у УО уже есть непустые суммы.
     * Это только подсказка для блокировки селекта категории на фронте - окончательное решение
     * в любом случае принимает сервер при смене шага согласования, поэтому ошибка загрузки
     * не должна блокировать интерфейс (fail-open): 404 - тихо пустой список, любая другая
     * ошибка - тост и тоже пустой список.
     */
    private async loadUOBusyCategories() {
        let result: any[] = [];
        const params = { curYear: this.curYear, abp: this.curAbp.abp, dataType: this.curDataType.code, region: this.curRegion.code, variant: this.curVariant.variant_uuid, prg: this.curProg.prg, ppr: this.curSubProg ? this.curSubProg.ppr: -1 };
        try {
            const response = await fetch(`/api-py/get-budget-events-uo-busy-categories/${encodeURI(JSON.stringify(params))}`);
            if (response.status === 200) {
                result = await response.json();
            } else if (response.status !== 404) {
                makeToast(this, 'danger', 'Ошибка get-budget-events-uo-busy-categories', `${response.status} - ${response.statusText}`);
            }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка get-budget-events-uo-busy-categories', (error as Error).toString());
        }
        return result;
    }

    /**
     * пустая ППР приходит с сервера как null (так она хранится в БД), а в параметрах фильтра
     * фронта используется -1. Приводим обе конвенции к единому виду - null.
     */
    private normalizePpr(ppr: any): any {
        return (ppr === -1 || ppr === undefined) ? null : ppr;
    }

    private isCategoryBusy(prg: any, ppr: any, project: any, category: any): boolean {
        const pprNorm = this.normalizePpr(ppr);
        return this.uoBusyCategories.some((el: any) => el.prg === prg && this.normalizePpr(el.ppr) === pprNorm && el.project === project && el.category === category);
    }

    private categoryDisabledTitle(guEl: any): string {
        if (!guEl.category_editable) { return this.getBudgetText('budget-event.category-no-access'); }
        if (guEl.category_busy) { return this.getBudgetText('budget-event.category-busy-uo'); }
        return '';
    }

    private async loadCategoryData(params: any) {
        try {
            const url = '/api-py/get-budget-events-category';
            let response: any = await fetch(url, {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(params)
            });
            response = await response.json();
            return response;
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка get-budget-events-category', (error as Error).toString());
            return null;
        }
    }

    /**
     * ввод цифр
     */
     private noAbc(evt: any) {
        // eslint-disable-next-line require-unicode-regexp
        const regex = new RegExp('^-?\\d*\\.?\\d{0,9}$');
        const key = String.fromCharCode(!evt.charCode ? evt.which : evt.charCode);
        if (!regex.test(key)) {
            evt.preventDefault();
            return false;
        }
    }

    private clkCollapse(indx: number | null, guIndx: number | null) {
        if (indx === null) {
            this.collapseAll = !this.collapseAll;
            for (const el of this.dataLst) {
                this.$set(el, 'collapse', this.collapseAll);
            }
        } else {
            let collapse = false;
            if (guIndx == null) {
                collapse = !this.dataLst[indx].collapse;
                this.$set(this.dataLst[indx], 'collapse', collapse);
            } else {
                collapse = !this.dataLst[indx].items[guIndx].collapse;
                this.$set(this.dataLst[indx].items[guIndx], 'collapse', collapse);
            }
            if (this.collapseAll && !collapse) {
                for (const el of this.dataLst) {
                    if (el.collapse) { return; }
                }
                this.collapseAll = false;
            } else if (!this.collapseAll && collapse) {
                for (const el of this.dataLst) {
                    if (!el.collapse) { return; }
                }
                this.collapseAll = true;
            }
        }
    }

    /**
     * изменение значения
     * @param obj объект
     * @param fieldNumber номер поля 0-3
     * @param indxSpf индекс dataLst
     * @param indxGu индекс ГУ
     */
     private chgValue(obj: any, fieldNumber: string, indx: number, indxGu: number) {
        const fieldName = `abp_value${fieldNumber}`
        if (isNaN(obj[fieldName]) || obj[fieldName]==='') { this.$set(obj, fieldName, 0); }
        obj[fieldName] = (Math.round(parseFloat(obj[fieldName]) * 10))/10;
        this.dataLst[indx].items[indxGu].totalSum[fieldName] = 0;
        for (const el of this.dataLst[indx].items[indxGu].items) {
            const value =  el[fieldName] ? el[fieldName] : 0;
            this.dataLst[indx].items[indxGu].totalSum[fieldName] += value;
        }
        this.dataLst[indx].totalSum[fieldName] = 0;
        for (const el of this.dataLst[indx].items) {
            const value =  el.totalSum[fieldName] ? el.totalSum[fieldName] : 0;
            this.dataLst[indx].totalSum[fieldName] += value;
        }
        this.totalSum[fieldName] = 0;
        for (const el of this.dataLst) {
            this.totalSum[fieldName] += el.totalSum[fieldName] ?? 0;
        }
        this.updDirty();
    }

    private addJust(indx: number) {
        this.selectedProjIndx = indx;
        this.justTxt = this.dataLst[indx].justTxt;
        this.justEditable = this.dataLst[indx].just_editable;
        this.showJustModal = true;
    }

    private async saveJustTxt() {
        if (this.selectedProjIndx == null) { return; }
        const projObj = this.dataLst[this.selectedProjIndx];
        const oldJustTxt = projObj.justTxt;
        this.justTxt = this.justTxt.trim();
        this.showJustModal = false;
        // текст не изменился - запрос не нужен (в т.ч. пустой текст при отсутствии обоснования)
        if (this.justTxt === (oldJustTxt ?? '')) { return; }
        projObj.justTxt = this.justTxt;
        const saveObj = { justTxt: this.justTxt ? this.justTxt: null, abp: this.curAbp.abp, variant: this.curVariant.variant_uuid, prg: projObj.prg.prg, ppr: projObj.ppr.ppr, project: projObj.project.code }
        try {
            const url = '/api-py/save-budget-events-justification';
            let response: any = await fetch(url, {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(saveObj)
            });
            response = await response.json();
            const resultLst: any[] = Array.isArray(response) ? response : [];
            let success = true;
            for (const r of resultLst) {
                if (r.result !== 'success') {
                    success = false;
                    makeToast(this, 'danger', 'Сообщение', `${this.tblTitle.saving} ${r.errTxt ? r.errTxt: r.result}`);
                }
            }
            if (!success) { projObj.justTxt = oldJustTxt; }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка сохранения', (error as Error).toString());
            projObj.justTxt = oldJustTxt;
        }
    }

    private clkJustClear() {
        this.justTxt = '';
    }

    private clkJustCancel() {
        this.showJustModal = false;
    }

    private async loadAllCategory() {
        try {
            const result = await fetch('api-py/get-dict-events-category/');
            if (result.status === 200) {
                const json = await result.json();
                this.categoryBase = json;
            } else {
                makeToast(this, 'danger', 'get-dict-events-category', `${result.status} - ${result.statusText}`);
            }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка запроса get-dict-events-category', (error as Error).toString());
        }
    }

    private setHistDataMap(dataLst: any[]) {
        const newDataLst = JSON.parse(JSON.stringify(dataLst));
        const resultMap = new Map();
        const catResultMap = new Map(); // история категорий
        for (const el of newDataLst) {
            const guMap = new Map();
            const guCatMap = new Map();
            for (const elGu of el.items) {
                const spfMap = new Map();
                for (const spfEl of elGu.items) {
                    spfMap.set(spfEl.spf.spf, spfEl);
                }
                guMap.set(elGu.gu.code, spfMap);
                // --
                const objCat = {category: elGu.category};
                guCatMap.set(elGu.gu.code, objCat);
                // --
            }
            const key = this.projKey(el.prg.prg, el.ppr.ppr, el.project.code);
            catResultMap.set(key, guCatMap);
            resultMap.set(key, guMap);
        }
        this.histCategoryMap = catResultMap;
        this.histDataMap = resultMap;
        this.updDirty();
    }

    /**
     * отличаются ли суммы АБП строки от снимка (все 3 года, независимо от режима "1 год")
     * @param histSpf строка из снимка
     * @param spfEl текущая строка
     */
    private isValuesChanged(histSpf: any, spfEl: any): boolean {
        const value0 = spfEl.abp_value0 ? spfEl.abp_value0 : null;
        const value1 = spfEl.abp_value1 ? spfEl.abp_value1 : null;
        const value2 = spfEl.abp_value2 ? spfEl.abp_value2 : null;
        const histVal0 = histSpf.abp_value0 ? histSpf.abp_value0 : null;
        const histVal1 = histSpf.abp_value1 ? histSpf.abp_value1 : null;
        const histVal2 = histSpf.abp_value2 ? histSpf.abp_value2 : null;
        return histVal0 !== value0 || histVal1 !== value1 || histVal2 !== value2;
    }

    /**
     * есть ли несохранённые изменения: категории и суммы АБП. Тот же обход, что в getSaveArr, - только видимые
     * строки dataLst (снимок шире из-за фильтра по статусу), выход на первом отличии
     */
    private hasChanges(): boolean {
        if (!this.histDataMap || !this.histCategoryMap) { return false; }
        for (const el of this.dataLst) {
            const key = this.projKey(el.prg.prg, el.ppr.ppr, el.project.code);
            const mapProj = this.histDataMap.get(key);
            const mapCatProj = this.histCategoryMap.get(key);
            if (!mapProj || !mapCatProj) { continue; }
            for (const elGu of el.items) {
                const catGu = mapCatProj.get(elGu.gu.code);
                if (catGu && catGu.category !== elGu.category) { return true; }
                const mapGu = mapProj.get(elGu.gu.code);
                if (!mapGu) { continue; }
                for (const elSpf of elGu.items) {
                    const spfHist = mapGu.get(elSpf.spf.spf);
                    if (spfHist && this.isValuesChanged(spfHist, elSpf)) { return true; }
                }
            }
        }
        return false;
    }

    private updDirty() {
        this.isDirty = this.hasChanges();
    }

    /**
     * для родителя: снять фокус с поля ввода (сработает change -> chgValue -> updDirty синхронно)
     * и вернуть, есть ли несохранённые изменения. Родитель спрашивает напрямую перед каждым переходом
     */
    public flushAndCheck(): boolean {
        const el = document.activeElement as HTMLElement | null;
        if (el && this.$el.contains(el)) { el.blur(); }
        this.updDirty();
        return this.isDirty;
    }

    /**
     * сохранение перед уходом со вкладки или сменой фильтра: без перезагрузки, снимок при полном успехе обновляет saveClkInner.
     * При частичном сохранении saveClk сам показывает отклонённые строки (с заголовком для перехода)
     */
    public async saveBeforeLeave(): Promise<boolean> {
        return (await this.saveClk(false, this.tblTitle.partial_save_title_leave)).ok;
    }

    /**
     * отказ от несохранённых правок: таблица пустая до прихода новых данных,
     * иначе при обрыве каскада фильтра старые правки остались бы на экране без баннера
     */
    public discardChanges() {
        this.dataLst = [];
        this.histDataMap = null;
        this.histCategoryMap = null;
        this.isDirty = false;
        this.totalSum = { abp_value0: 0, gu_value0: 0, uo_value0: 0, abp_value1: 0, gu_value1: 0, uo_value1: 0, abp_value2: 0, gu_value2: 0, uo_value2: 0 };
    }

    private getSaveArr() {
        const saveArr: any[]= [];
        const saveCatArr: any[] = [];
        if (!this.histDataMap || !this.histCategoryMap) { return {saveArr: [], saveCatArr: []}; }
        for (const el of this.dataLst) {
            const key = this.projKey(el.prg.prg, el.ppr.ppr, el.project.code);
            const mapProj = this.histDataMap.get(key);
            const mapCatProj = this.histCategoryMap.get(key);
            if (mapProj && mapCatProj) {
                for (const elGu of el.items) {
                    const mapGu = mapProj.get(elGu.gu.code);
                    const catGu = mapCatProj.get(elGu.gu.code);
                    if (catGu.category !== elGu.category) {
                        const obj = { project: el.project.code, prg: el.prg.prg, ppr: el.ppr.ppr, gu: elGu.gu.code, category: elGu.category }
                        saveCatArr.push(obj);
                    }
                    if (mapGu) {
                        for (const elSpf of elGu.items) {
                            const spfHist = mapGu.get(elSpf.spf.spf);
                            if (spfHist) {
                                if (this.isValuesChanged(spfHist, elSpf)) {
                                    const value0 = elSpf.abp_value0 ? elSpf.abp_value0 : null;
                                    const value1 = elSpf.abp_value1 ? elSpf.abp_value1 : null;
                                    const value2 = elSpf.abp_value2 ? elSpf.abp_value2 : null;
                                    const obj = { project: el.project.code, prg: el.prg.prg, ppr: el.ppr.ppr, gu: elGu.gu.code, spf: elSpf.spf.spf, abp_value0: value0, abp_value1: value1, abp_value2: value2 }
                                    saveArr.push(obj);
                                }
                            }
                        }
                    }
                }
            }
        }
        return {saveArr: saveArr, saveCatArr: saveCatArr};
    }

    /**
     * @param flLoad перезагрузить данные после полного успеха
     * @param partialTitle заголовок окна отклонённых строк (для перехода); без него - прежний
     */
    private async saveClk(flLoad = true, partialTitle?: string): Promise<iSaveResult> {
        if (this.savingFl) { return { ok: false, rejected: [] }; } // сохранение уже идёт
        this.savingFl = true;
        try {
            return await this.saveClkInner(flLoad, partialTitle);
        } catch (error) {
            makeToast(this, 'danger', this.tblTitle.saving, (error as Error).toString());
            return { ok: false, rejected: [] };
        } finally {
            this.savingFl = false;
        }
    }

    private async saveClkInner(flLoad: boolean, partialTitle?: string): Promise<iSaveResult> {
        if (!this.histDataMap || !this.histCategoryMap) { return { ok: false, rejected: [] }; }
        const resSave = this.getSaveArr();
        const saveArr: any[] = resSave.saveArr;
        const saveCatArr: any[] = resSave.saveCatArr;

        if (!saveCatArr.length && !saveArr.length) {
            makeToast(this, 'warning', this.tblTitle.saving, this.tblTitle.no_changes_to_save);
            return { ok: false, rejected: [] };
        }

        // фронтовой барьер "категория обязательна при непустых суммах АБП"
        // сервер такую группу (prg, ppr, project, gu) откатывает целиком - не даём ей улететь
        // в пакете вместе с годными группами, чтобы их правки не терялись заодно с чужими
        const categoryCheck = this.excludeCategoryRequiredGroups(saveArr, saveCatArr);
        const rejected: iSaveGroupRejected[] = [...categoryCheck.rejected];

        let hasBadResponse = false; // хотя бы один кусок вернул null - fail-closed, но без дублирования сообщения
        let formError: iSaveResponse | null = null; // отказ уровня формы - одинаков у всех кусков, показываем один раз

        if (categoryCheck.saveArr.length || categoryCheck.saveCatArr.length) {
            const chunks = this.splitSaveArrIntoChunks(categoryCheck.saveArr, categoryCheck.saveCatArr);
            const tasks = chunks.map((chunk) => () => this.savePackage(chunk.saveArr, chunk.saveCatArr));
            const responses = await this.runWithConcurrencyLimit(tasks, SAVE_CHUNK_CONCURRENCY);

            for (const saveResponse of responses) {
                if (!saveResponse) {
                    hasBadResponse = true;
                    continue;
                }
                if (saveResponse.result === 'error') {
                    if (!formError) { formError = saveResponse; }
                    continue;
                }
                if (saveResponse.groups && saveResponse.groups.length) {
                    rejected.push(...saveResponse.groups);
                }
            }
        }
        // иначе - все затронутые группы отсеяны барьером категории, на сервер отправлять нечего

        if (formError) {
            makeToast(this, 'danger', this.tblTitle.saving, formError.errTxt || this.tblTitle.save_bad_response);
            return { ok: false, rejected: [] };
        }

        if (hasBadResponse) {
            // fail-closed: негодный ответ хотя бы у одного куска (сеть, 5xx, прокси, неожиданная
            // форма JSON) - неизвестно, что из него записалось, общий исход не ok. Отката на
            // старые эндпоинты нет, их больше не существует
            makeToast(this, 'danger', this.tblTitle.saving, this.tblTitle.save_bad_response);
            return { ok: false, rejected: [] };
        }

        if (!rejected.length) {
            // сохранилось всё, из всех кусков: снимок можно привести к форме целиком
            makeToast(this, 'success', this.tblTitle.saving, this.tblTitle.data_saved);
            if (flLoad) {
                await this.loadData();
                await this.checkupSave();
            } else {
                // техническое сохранение внутри Действия - без перезагрузки, иначе те же
                // изменения снова сочтутся несохранёнными
                this.setHistDataMap(this.dataLst);
            }
            return { ok: true, rejected: [] };
        }

        // частичное сохранение (решение 25.09): согласование не продолжается
        this.showPartialSaveModal(rejected, partialTitle);
        return { ok: false, rejected };
    }

    /**
     * фронтовой барьер "категория обязательна при непустых суммах АБП" (task-eak-726): те же
     * условия, что проверяет сервер при сохранении - без запросов, по данным самой формы.
     * Проверяются только группы, реально попадающие в этот пакет (saveArr/saveCatArr) - легаси
     * ГУ, которых пользователь не трогал, сервер тоже не смотрит. "Плохие" элементы исключаются
     * из обоих массивов и возвращаются отдельным списком в формате ответа сервера (errCode
     * CATEGORY_REQUIRED), чтобы showPartialSaveModal не отличала фронтовой отказ от серверного.
     */
    private excludeCategoryRequiredGroups(saveArr: any[], saveCatArr: any[]):
        { saveArr: any[]; saveCatArr: any[]; rejected: iSaveGroupRejected[] } {
        const groups = new Map<string, { prg: number; ppr: any; project: string; gu: string }>();
        for (const el of [...saveArr, ...saveCatArr]) {
            const key = this.groupKey(el.prg, el.ppr, el.project, el.gu);
            if (!groups.has(key)) {
                groups.set(key, { prg: el.prg, ppr: el.ppr, project: el.project, gu: el.gu });
            }
        }

        const badKeys = new Set<string>();
        const rejected: iSaveGroupRejected[] = [];
        const errTxt = this.getBudgetText('budget-event.category-not-filled');
        for (const [key, group] of groups) {
            if (!this.isCategoryRequiredBad(group.prg, group.ppr, group.project, group.gu)) { continue; }
            badKeys.add(key);
            const pprNorm = this.normalizePpr(group.ppr);
            rejected.push({
                prg: group.prg,
                ppr: pprNorm === null ? -1 : pprNorm,
                project: group.project,
                gu: group.gu,
                errCode: 'CATEGORY_REQUIRED',
                errTxt
            });
        }

        if (!badKeys.size) { return { saveArr, saveCatArr, rejected: [] }; }
        return {
            saveArr: saveArr.filter((el) => !badKeys.has(this.groupKey(el.prg, el.ppr, el.project, el.gu))),
            saveCatArr: saveCatArr.filter((el) => !badKeys.has(this.groupKey(el.prg, el.ppr, el.project, el.gu))),
            rejected
        };
    }

    /**
     * "плохая" группа - категория ГУ в форме пуста, а хотя бы одна специфика этого ГУ по
     * этому мероприятию имеет непустую и ненулевую сумму АБП (ноль приравнивается к пустому -
     * так же считает сервер). Суммы берутся по всем спецификам ГУ в форме, а не только по
     * изменённым: сервер проверяет итоговое состояние группы, а не то, что пришло в запросе.
     */
    private isCategoryRequiredBad(prg: any, ppr: any, project: any, gu: any): boolean {
        const guNode = this.findGuNode(prg, ppr, project, gu);
        if (!guNode) { return false; } // группы без узла в текущей форме не блокируем
        if (guNode.category !== null && guNode.category !== undefined && guNode.category !== '') { return false; }
        return guNode.items.some((elSpf: any) => Boolean(elSpf.abp_value0) || Boolean(elSpf.abp_value1) || Boolean(elSpf.abp_value2));
    }

    /**
     * ключ группы (prg, ppr, project, gu) - единица нарезки пакета на куски. Использует
     * ту же нормализацию ppr, что и projKey/histDataMap/histCategoryMap/getSaveArr, вторую
     * конвенцию не заводим.
     */
    private groupKey(prg: any, ppr: any, project: any, gu: any): string {
        return `${this.projKey(prg, ppr, project)}_${gu}`;
    }

    /**
     * режет saveArr/saveCatArr на куски не более чем по SAVE_CHUNK_GROUP_SIZE групп
     * (prg, ppr, project, gu) в каждом. Все элементы одной группы - и её строки из saveArr,
     * и её запись из saveCatArr, если есть - всегда попадают в один и тот же кусок: иначе
     * серверная проверка "категория заполнена там, где есть суммы АБП" в одном запросе
     * увидит полузаписанную группу из другого запроса и отклонит её без причины.
     */
    private splitSaveArrIntoChunks(saveArr: any[], saveCatArr: any[]): Array<{ saveArr: any[]; saveCatArr: any[] }> {
        const order: string[] = [];
        const itemsByKey = new Map<string, any[]>();
        const catItemsByKey = new Map<string, any[]>();
        const ensureKey = (key: string) => {
            if (!itemsByKey.has(key)) {
                itemsByKey.set(key, []);
                catItemsByKey.set(key, []);
                order.push(key);
            }
        };
        for (const el of saveArr) {
            const key = this.groupKey(el.prg, el.ppr, el.project, el.gu);
            ensureKey(key);
            itemsByKey.get(key)!.push(el);
        }
        for (const el of saveCatArr) {
            const key = this.groupKey(el.prg, el.ppr, el.project, el.gu);
            ensureKey(key);
            catItemsByKey.get(key)!.push(el);
        }

        const chunks: Array<{ saveArr: any[]; saveCatArr: any[] }> = [];
        for (let i = 0; i < order.length; i += SAVE_CHUNK_GROUP_SIZE) {
            const keysChunk = order.slice(i, i + SAVE_CHUNK_GROUP_SIZE);
            const chunkSaveArr: any[] = [];
            const chunkSaveCatArr: any[] = [];
            for (const key of keysChunk) {
                chunkSaveArr.push(...itemsByKey.get(key)!);
                chunkSaveCatArr.push(...catItemsByKey.get(key)!);
            }
            chunks.push({ saveArr: chunkSaveArr, saveCatArr: chunkSaveCatArr });
        }
        return chunks;
    }

    /**
     * простой пул: не больше limit задач одновременно в полёте, по завершении любой -
     * следующая из очереди. Без внешних библиотек, порядок результатов совпадает с порядком tasks.
     */
    private async runWithConcurrencyLimit<T>(tasks: Array<() => Promise<T>>, limit: number): Promise<T[]> {
        const results: T[] = new Array(tasks.length);
        let nextIndex = 0;
        const worker = async () => {
            while (nextIndex < tasks.length) {
                const cur = nextIndex++;
                results[cur] = await tasks[cur]();
            }
        };
        const workerCount = Math.min(limit, tasks.length);
        const workers: Promise<void>[] = [];
        for (let i = 0; i < workerCount; i++) {
            workers.push(worker());
        }
        await Promise.all(workers);
        return results;
    }

    /**
     * запрос к единому эндпоинту сохранения. Возвращает null при любой невозможности разобрать
     * ответ как ожидаемый контракт - вызывающий код обязан трактовать null как fail-closed отказ.
     */
    private async savePackage(saveArr: any[], saveCatArr: any[]): Promise<iSaveResponse | null> {
        const saveObj = {
            curYear: this.curYear,
            region: this.curRegion.code,
            variant: this.curVariant.variant_uuid,
            dataType: this.curDataType.code,
            abp: this.curAbp.abp,
            userId: this.usrId,
            locale: this.$i18n.locale,
            items: saveArr,
            categoryItems: saveCatArr
        };
        try {
            const url = '/api-py/save-budget-events-abp';
            const response: any = await fetch(url, {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(saveObj)
            });
            if (response.status !== 200) { return null; }
            const json = await response.json();
            if (!json || typeof json !== 'object' || (json.result !== 'success' && json.result !== 'error') || !Array.isArray(json.groups)) {
                return null;
            }
            return json as iSaveResponse;
        } catch (error) {
            console.error('save-budget-events-abp', error);
            return null;
        }
    }

    /**
     * ключ проекта в единой конвенции: -1/undefined ppr (сентинел сервера) и null (сентинел
     * фронта) приводятся normalizePpr к одному виду, затем - к тому же '00', что уже
     * используется в histDataMap/histCategoryMap/getSaveArr.
     */
    private projKey(prg: any, ppr: any, project: any): string {
        const pprNorm = this.normalizePpr(ppr);
        return `${prg}_${pprNorm || '00'}_${project}`;
    }

    private findProjectNode(prg: any, ppr: any, project: any): any {
        const pprNorm = this.normalizePpr(ppr);
        return this.dataLst.find((el: any) => el.prg.prg === prg && this.normalizePpr(el.ppr.ppr) === pprNorm && el.project.code === project) || null;
    }

    private findGuNode(prg: any, ppr: any, project: any, gu: any): any {
        const projNode = this.findProjectNode(prg, ppr, project);
        if (!projNode) { return null; }
        return projNode.items.find((el: any) => el.gu.code === gu) || null;
    }

    /**
     * список строк, отклонённых при частичном сохранении, для c-partial-save-modal. Названия
     * ГУ и мероприятий сервер не присылает - подставляются из dataLst по ключу группы.
     */
    private showPartialSaveModal(rejected: iSaveGroupRejected[], partialTitle?: string) {
        const rows = rejected.map((g: iSaveGroupRejected) => {
            const projNode = this.findProjectNode(g.prg, g.ppr, g.project);
            const guNode = this.findGuNode(g.prg, g.ppr, g.project, g.gu);
            return {
                prg: g.prg,
                ppr: projNode ? projNode.ppr.ppr : this.normalizePpr(g.ppr),
                project: projNode ? projNode.project : { code: g.project, name: '' },
                gu: guNode ? guNode.gu : { code: g.gu, name: '' },
                errTxt: g.errTxt
            };
        });
        // eslint-disable-next-line
        // @ts-ignore
        this.$refs.partialSaveRef.showEvent(rows, partialTitle);
    }

    private async checkupSave() {
        const result = await this.loadCheckupData();
        if (!result) { return; }
        this.checkupData = result;
        // eslint-disable-next-line
        // @ts-ignore
        this.$refs.checkupRef.showEvent(result);
    }

    private async loadCheckupData() {
        const params = { curYear: this.curYear, abp: this.curAbp.abp, dataType: this.curDataType.code, region: this.curRegion.code, variant: this.curVariant.variant_uuid, prg: this.curProg.prg, ppr: this.curSubProg ? this.curSubProg.ppr: -1, locale: this.$i18n.locale };
        const url ='/api-py/checkup-budget-events-gu-abp-for-abp';
        try {
            let response: any = await fetch(url, {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(params)
            });
            response = await response.json();
            return response;
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка загрузки', (error as Error).toString());
            return null;
        }
    }

    private async copyGuDataClk() {
        if (!this.dataLst.length) { return; }
        let fl = false;
        await this.$bvModal.msgBoxConfirm('Вы копируете "суммы, заявленные гу" в "суммы поддерживаемые УО/АБП". После копирования все ранее введённые суммы АБП будут изменены.', {
            title: 'Предупреждение',
            okVariant: 'danger',
            okTitle: 'Подтвердить',
            cancelTitle: 'Отменить',
            centered: true,
            size: 'lg',
            buttonSize: 'sm',
            footerClass: 'p-2',
            hideHeaderClose: false,
            noCloseOnBackdrop: true
        })
        .then(value => {
            if (value) { fl = true; }
        })
        .catch(err => {
            console.error(err);
        });
        if (!fl) { return; }

        for (const elProj of this.dataLst) {
            elProj.totalSum.abp_value0 = 0;
            elProj.totalSum.abp_value1 = 0;
            elProj.totalSum.abp_value2 = 0;
            for (const elGu of elProj.items) {
                elGu.totalSum.abp_value0 = 0;
                elGu.totalSum.abp_value1 = 0;
                elGu.totalSum.abp_value2 = 0;
                for (const elSpf of elGu.items) {
                    elSpf.abp_value0 = elSpf.gu_value0;
                    elSpf.abp_value1 = elSpf.gu_value1;
                    elSpf.abp_value2 = elSpf.gu_value2;
                    elGu.totalSum.abp_value0 += elSpf.abp_value0 ? elSpf.abp_value0: 0;
                    elGu.totalSum.abp_value1 += elSpf.abp_value1 ? elSpf.abp_value1: 0;
                    elGu.totalSum.abp_value2 += elSpf.abp_value2 ? elSpf.abp_value2: 0;
                }
                elProj.totalSum.abp_value0 += elGu.totalSum.abp_value0;
                elProj.totalSum.abp_value1 += elGu.totalSum.abp_value1;
                elProj.totalSum.abp_value2 += elGu.totalSum.abp_value2;
            }
        }
        this.updDirty();
    }

    // ------------------ согласование --------------------
    private clkCheck(projIndx: number | null, guIndx: number | null, spfIndx: number | null) {
            // выбрать всё
        if (projIndx === null) {
            for (const proj of this.dataLst) {
                if (proj.checked !== undefined && proj.checked !== null) {
                    proj.checked = this.checkedAll;
                }

                for (const gu of proj.items) {
                    if (gu.checked !== undefined && gu.checked !== null) {
                        gu.checked = this.checkedAll;
                    }

                    for (const spf of gu.items) {
                        if (spf.checked !== undefined && spf.checked !== null) {
                            spf.checked = this.checkedAll;
                        }
                    }
                }
            }
            return;
        }

        const projEl = this.dataLst[projIndx];

        // клик по проекту
        if (guIndx === null) {
            for (const gu of projEl.items) {
                if (gu.checked !== undefined && gu.checked !== null) {
                    gu.checked = projEl.checked;
                }

                for (const spf of gu.items) {
                    if (spf.checked !== undefined && spf.checked !== null) {
                        spf.checked = projEl.checked;
                    }
                }
            }
        }
        else {
            const guEl = projEl.items[guIndx];

            // клик по gu
            if (spfIndx === null) {
                for (const spf of guEl.items) {
                    if (spf.checked !== undefined && spf.checked !== null) {
                        spf.checked = guEl.checked;
                    }
                }
            }

            // пересчитать gu по spf
            guEl.checked = guEl.items
                .filter((x: any) => x.checked !== undefined && x.checked !== null)
                .every((x: any) => x.checked);
        }

        // пересчитать проект по gu
        projEl.checked = projEl.items
            .filter((x: any) => x.checked !== undefined && x.checked !== null)
            .every((x: any) => x.checked);

        // пересчитать checkedAll
        this.checkedAll = this.dataLst
            .filter((x: any) => x.checked !== undefined && x.checked !== null)
            .every((x: any) => x.checked);
    }

    private async loadAgreementProjLvl() {
        if (!this.operationCodeProj.length) { await this.loadOperationsProj(); }
        const params = { curYear: this.curYear, abp: this.curAbp.abp, dataType: this.curDataType.code, region: this.curRegion.code, variant: this.curVariant.variant_uuid, prg: this.curProg.prg, ppr: this.curSubProg ? this.curSubProg.ppr: null, mode_code: this.modeCode, operation_code: this.operationCodeProj };
        let result = null;
        try {
            const response: any = await fetch(`/api-py/get-budget-event-agreement-proj-lvl/${encodeURI(JSON.stringify(params))}`);
            if (response.status === 200) {
                result = await response.json();
            } else {
                makeToast(this, 'danger', 'Ошибка get-budget-event-agreement-proj-lvl',  `${response.status} - ${response.statusText}`);
                return new Map();
            }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка get-budget-event-agreement-proj-lvl', (error as Error).toString());
            return new Map();
        }
        return this.getAgrProjLvlMap(result);
    }

    private getAgrProjLvlMap(agrLst: any[]) {
        const result = new Map<string, any>();
        for (const el of agrLst) {
            const key = `${el.prg}_${el?.ppr ?? '00'}_${el.project_code}`;
            result.set(key, el)
        }
        return result;
    }

    private async loadAgreementGuLvl() {
        if (!this.operationCode.length) { await this.loadOperations(); }
        if (!this.curGuLst) { return  new Map(); }
        const guLst = [];
        for (const el of this.curGuLst) {
            guLst.push(el.code);
        }
        const params = { curYear: this.curYear, abp: this.curAbp.abp, dataType: this.curDataType.code, region: this.curRegion.code, variant: this.curVariant.variant_uuid, guLst: guLst, prg: this.curProg.prg, ppr: this.curSubProg ? this.curSubProg.ppr: null, mode_code: this.modeCode, operation_code: this.operationCode };
        let result = null;
        try {
            const response: any = await fetch(`/api-py/get-budget-event-agreement-gu-lvl/${encodeURI(JSON.stringify(params))}`);
            if (response.status === 200) {
                result = await response.json();
            } else {
                makeToast(this, 'danger', 'Ошибка get-budget-event-agreement-gu-lvl',  `${response.status} - ${response.statusText}`);
                return new Map();
            }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка get-budget-event-agreement-gu-lvl', (error as Error).toString());
            return new Map();
        }
        return this.getAgrGuLvlMap(result);
    }

    private getAgrGuLvlMap(agrLst: any[]) {
        const result = new Map<
        string,
        Map<string, Map<string, any>>
        >();

        for (const el of agrLst) {
            const key = `${el.prg}_${el?.ppr ?? '00'}_${el.project_code}`;
            const guKey = el.gu ?? 'null';
            const spfKey = el.spf;

            // Создаем Map для key
            if (!result.has(key)) {
                result.set(key, new Map());
            }

            const guMap = result.get(key)!;

            // Создаем Map для gu
            if (!guMap.has(guKey)) {
                guMap.set(guKey, new Map());
            }

            const spfMap = guMap.get(guKey)!;

            // Кладем элемент
            spfMap.set(spfKey, el);
        }

        return result;
    }

    private async loadOperations() {
        this.operationCode = [];
        if (this.usrId === null) {
            this.chgAgrAccess();
            return;
        }
        let result = null;
        try {
            result = await fetch(encodeURI(`/api/um/module/link?user=${this.usrId}&modulecode=${this.moduleCode}`));
            if (result.status === 200) {
                result = await result.json();
            }  else {
                if (result.status !== 404) { makeToast(this, 'danger', 'Ошибка загрузки операций пользователя', `${result.status}  ${result.statusText}`); }
                return;
            }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка загрузки операций пользователя', (error as Error).toString());
            return;
        }
        if (result.operations) {
            for (const el of result.operations) {
                this.operationCode.push(el);
            }
        }
        this.chgAgrAccess();
    }

    private chgAgrAccess() {
        let fl  = false;
        if (this.operationCode.length > 0 || this.operationCodeProj.length > 0) {
            fl = true;
        }
        this.$emit('chgAgrAccess', fl);
    }

    private async loadOperationsProj() {
        this.operationCodeProj = [];
        if (this.usrId === null) {
            this.chgAgrAccess();
            return;
        }
        let result = null;
        try {
            result = await fetch(encodeURI(`/api/um/module/link?user=${this.usrId}&modulecode=${this.moduleCodeUO}`));
            if (result.status === 200) {
                result = await result.json();
            }  else {
                if (result.status !== 404) { makeToast(this, 'danger', 'Ошибка загрузки операций пользователя', `${result.status}  ${result.statusText}`); }
                return;
            }
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка загрузки операций пользователя', (error as Error).toString());
            return;
        }
        if (result.operations) {
            for (const el of result.operations) {
                this.operationCodeProj.push(el);
            }
        }
        this.chgAgrAccess();
    }

    private agrLogClk(projIndx: number, guIndx: number | null, spfIndx: number | null) {
        let id = null;
        let agrObj: any = null;
        if (guIndx!=null && spfIndx!=null) {
            const agr = this.dataLst[projIndx].items[guIndx].items[spfIndx].agrGuLvl;
            id = agr.agr_id;
            agrObj = this.getCurrentStatusObjForLog(agr);
        } else {
            const agr = this.dataLst[projIndx].agrProjLvl;
            if (!agr) { return; }
            id = agr.agr_id;
            agrObj = this.getCurrentStatusObjForLog(agr);
        }
        if (id == null) { return; }

        // eslint-disable-next-line
        // @ts-ignore
        this.$refs.refAgrLogModal.showEvent(id, agrObj);
    }

    private getCurrentStatusObjForLog(agr: any) {
        let agrObj: any = null;
        if (agr) {
            agrObj = {
                userId: agr.user_id,
                status: agr.status.code,
                name_ru: agr.status ? agr.status.name_ru: '',
                name_kk: agr.status ? agr.status.name_kk: '',
                name_en: agr.status ? agr.status.name_en: '',
                updateDate: agr.update_date,
                commentTxt: agr.comment_txt
            }
        }
        return agrObj;
    }

    private async checkAgrEventSaved() {
        const resSave = this.getSaveArr();
        const saveArr: any[] = resSave.saveArr;
        const saveCatArr: any[] = resSave.saveCatArr;
        if (!saveArr.length && !saveCatArr.length) {
            return true;
        }
        let fl = false
        await this.$bvModal.msgBoxConfirm(this.tblTitle.check_agr_event_saved.text, {
            title: 'Предупреждение',
            okVariant: 'success',
            okTitle: this.tblTitle.check_agr_event_saved.yes,
            cancelTitle: this.tblTitle.check_agr_event_saved.cancel,
            centered: true,
            size: 'lg',
            buttonSize: 'sm',
            footerClass: 'p-2',
            hideHeaderClose: false,
            noCloseOnBackdrop: true
        })
        .then(value => {
            fl = value;
        })
        .catch(err => {
            console.error(err);
        });
        if (!fl) { return false; }
        // ok=false также при частичном сохранении (снимок для успешных групп saveClkInner уже
        // обновил точечно сам) - согласование в таком случае не продолжается, окно с отклонёнными
        // строками уже показано изнутри saveClk
        const saveResult = await this.saveClk(false);
        return saveResult.ok;
    }

    private async agreementEvent() {
        if (this.busy) { return; }
        this.agreeingFl = true;
        let modalOpened = false;
        try {
            modalOpened = (await this.agreementEventInner()) === true;
        } catch (error) {
            makeToast(this, 'danger', 'Согласование', (error as Error).toString());
        } finally {
            // если модалка открыта - флаг снимет agrClk или её закрытие (@closed)
            if (!modalOpened) { this.agreeingFl = false; }
        }
    }

    private async agreementEventInner() {
        const selectArrGu: any = [];
        const selectProjArr: any = [];
        this.selectArr = [];
        this.agrBtnLst = { back: [], forward: [] };
        let firstStatus: number | null = null;
        const notSameStatus = this.getBudgetText('other.notSameStatus'); // Выберите подпрограммы с одинаковым статусом
        const title = this.getBudgetText('other.no_program[0]'); // Согласование
        for (const elProj of this.dataLst) {
            if (elProj.checked && elProj.agrProjLvl && elProj.agrProjLvl.availableStep) {
                if (firstStatus === null) { firstStatus = elProj.agrProjLvl.status.code; }
                if (firstStatus !== elProj.agrProjLvl.status.code) {
                    makeToast(this, 'danger', title, `${notSameStatus}!`);
                    return;
                }
                selectProjArr.push({ prg: elProj.prg.prg, ppr: elProj.ppr.ppr, project_code: elProj.project.code, id: elProj.agrProjLvl.agr_id })
            }
            for (const elGu of elProj.items) {
                for (const elSpf of elGu.items) {
                    if (elSpf.checked) {
                        if (firstStatus === null) { firstStatus = elSpf.agrGuLvl.status.code; }
                        if (firstStatus !== elSpf.agrGuLvl.status.code) {
                                makeToast(this, 'danger', title, `${notSameStatus}!`);
                                return;
                        }
                        selectArrGu.push({ id: elSpf.agrGuLvl.agr_id })
                    }
                }
            }
        }
        let operationCode = [];
        if (this.typeAgr === 0) { // уровень ГУ
            this.selectArr = selectArrGu;
            operationCode = this.operationCode;
        } else {
            this.selectArr =  Array.from(
                new Map(
                    selectProjArr.map((item: any) => [
                        `${item.prg}_${item.ppr}_${item.project_code}_${item.id}`,
                        item
                    ])
                ).values()
            );
            operationCode = this.operationCodeProj;
        }
        if (!this.selectArr.length) {
            const nonSelected = this.getBudgetText('other.no_program[1]'); // Не выбрано ни одной программы/подпрограммы
            makeToast(this, 'warning', title, nonSelected);
            return;
        }

        const flCheckSaved = await this.checkAgrEventSaved();
        if (!flCheckSaved) { return; }
        // ---------------
        this.agrCurrentStatus = firstStatus;
        const params = { modeCode: this.modeCode, operationCode: operationCode, agrCode: firstStatus };

        let result: any = null;
        try {
            const response: any = await fetch(`/api-py/get-agreement-step-next-back/${encodeURI(JSON.stringify(params))}`);
            result = await response.json();
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка get-agreement-step-next-back', (error as Error).toString());
            this.progress = 0;
            return;
        }
        if (result.length === 0) {
            makeToast(this, 'warning', 'Согласование', 'Нет доступных шагов согласования!');
            return;
        }
        for (const el of result) {
            let name = el[`name_${this.$i18n.locale}`];
            if (!name) { name = el.name_ru; }
            el.name = name;
            if (el.stepType === 1) {
                this.agrBtnLst.back.push(el);
            } else {
                this.agrBtnLst.forward.push(el);
            }
        }
        // eslint-disable-next-line
        // @ts-ignore
        this.$refs.refAgrModal.showEvent();
        return true;
    }

    /**
     * закрытие модалки согласования без действия - снимаем флаг занятости
     */
    private agrModalClosed() {
        this.agreeingFl = false;
    }

    private async agrClk(data: any) {
        try {
            if (this.typeAgr === 0) {
                await this.saveAgreement(data, '/api-py/set_b_event_agreement_step_gu');
            } else {
                const obj = Object.assign({
                    cur_year: this.curYear,
                    region: this.curRegion.code,
                    variant: this.curVariant.variant_uuid,
                    data_type: this.curDataType.code,
                    abp: this.curAbp.abp
                }, data);
                await this.saveAgreement(obj, '/api-py/set_b_event_agreement_step_proj');
            }
        } catch (error) {
            makeToast(this, 'danger', 'Сохранение status', (error as Error).toString());
        } finally {
            this.agreeingFl = false; // согласование завершено, модалка уже закрыта самой clkBtn
        }
    }

    private async saveAgreement(data: any, url: string) {
        data.userId = store.state.user.sub;
        data.locale = this.$i18n.locale;
        data.module_code = this.moduleCode;
        data.currentStatus = this.agrCurrentStatus; // статус, который видел пользователь - для проверки на сервере
        const saveObj = Object.assign({
            userId: this.usrId,
            items: this.selectArr,
        }, data);
        let result: any = await fetch(url,
            {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(saveObj)
            });
        if (result.status === 200) {
            result = await result.json();
            const errTxtLst: string[] = [];
            for (const res of result) {
                if (res.result === 'error') {
                    console.error(`Ошибка ${url}`, res);
                    const txt = `${res.errTxt || res.data || ''}`;
                    if (txt.length && !errTxtLst.includes(txt)) { errTxtLst.push(txt); }
                }
            }
            if (errTxtLst.length) {
                makeToast(this, 'danger', 'Сохранение status', errTxtLst.join('; '));
            }
            await this.loadData();
        } else {
            makeToast(this, 'danger', 'Сохранение status', `Ошибка ${result.status} ${result.statusText}`);
            return;
        }
    }
    // ---------------------------------------------------


    // ---- переводы
    private getBudgetText(link: string) {  return getBudgetText(link); }

    private get tblTitle() {
        const obj = {
            saving: this.getBudgetText('sum_calc_edit.saving'), // Сохранение
            data_saved: this.getBudgetText('sum_calc_edit.data_saved'), // Данные сохранены
            load_data: this.getBudgetText('sum_calc_edit.load_data'), // Загрузка данных
            status: this.getBudgetText('sum_calc_abp.status'), // Статус
            change_log: this.getBudgetText('sum_calc_abp.change_log'), // Журнал изменений
            check_agr_event_saved: {
                text: this.getBudgetText('budget-event.check-agr-event-saved.text'), // Есть несохраненные изменения. Сохранить перед отправкой?
                yes: this.getBudgetText('budget-event.check-agr-event-saved.yes'), // Сохранить и продолжить
                cancel: this.getBudgetText('budget-event.check-agr-event-saved.cancel'), // Отменить
            },
            unsaved_banner: this.getBudgetText('budget-event.unsaved-changes.banner'), // Внимание: Есть несохраненные изменения!
            partial_save_title_leave: this.getBudgetText('budget-event.partial-save.title-leave'), // Форма сохранена частично, переход НЕ выполнен...
            no_changes_to_save: this.getBudgetText('budget-event.no-changes-to-save'), // Нет изменений для сохранения
            save_bad_response: this.getBudgetText('budget-event.save-bad-response') // Не удалось разобрать ответ сервера. Сохранение не выполнено
        }
        return obj
    }

}
